import { useCallback, useRef } from 'react'
import { Col, Row } from 'react-grid-system'
import {
  NormalFormEmailField,
  NormalFormPhoneField,
  NormalFormTextField
} from '../molecules'
import { useUserLanguage } from '@/customHooks'
import { CreateContactInput } from '@/graphql/generated'
import textsData from '@/textData/FormModalsTexts.json'

type AddContactFormControlledProps = {
  onChange: (data: CreateContactInput) => void
  defaultData?: CreateContactInput
}

const emptyData: CreateContactInput = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
}

export const AddContactFormControlled = ({ onChange, defaultData }: AddContactFormControlledProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.contactForm : textsData.en.contactForm

  const contactDataRef = useRef<CreateContactInput>(defaultData
    ? (
        {
          firstName: defaultData.firstName,
          lastName: defaultData.lastName,
          email: defaultData.email,
          phoneNumber: defaultData.phoneNumber,
        }
      )
    : emptyData
  )

  const onChangeHandle = useCallback((field: keyof CreateContactInput, value: string | null) => {
    contactDataRef.current = {
      ...contactDataRef.current,
      [field]: value,
    }
    onChange(contactDataRef.current)
  }, [])

  return (
    <>
      <Row>
        <Col>
          <NormalFormTextField
            name="contactFirstName"
            label={texts.firstName.label}
            placeholder={texts.firstName.placeholder}
            onChange={(value) => onChangeHandle('firstName', value)}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormTextField
            name="contactLastName"
            label={texts.lastName.label}
            placeholder={texts.lastName.placeholder}
            onChange={(value) => onChangeHandle('lastName', value)}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormEmailField
            label={texts.email.label}
            placeholder={texts.email.placeholder}
            name='contactEmail'
            onChange={(value) => onChangeHandle('email', value)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormPhoneField
            name="contactPhoneNumber"
            label={texts.phoneNumber.label}
            onChange={(value) => onChangeHandle('phoneNumber', value)}
            required
          />
        </Col>
      </Row>
    </>
  )
}